import countries from 'i18n-iso-countries';
import { useRouter } from 'next/router';
import enLocale from 'i18n-iso-countries/langs/en.json';
import plLocale from 'i18n-iso-countries/langs/pl.json';
import esLocale from 'i18n-iso-countries/langs/es.json';
import { getLanguage } from '@utils/misc';

const useCountry = (): {
  codeToName: (code: string, lang?: string) => string;
} => {
  const { locale } = useRouter();
  const language = getLanguage(locale);

  // TODO: think of automatic language imports
  countries.registerLocale(enLocale);
  countries.registerLocale(plLocale);
  countries.registerLocale(esLocale);

  const codeToName = (code: string, lang?: string): string => {
    const country = countries.getName(code, lang || language.toLowerCase());
    return country || code;
  };

  return { codeToName };
};

export default useCountry;
